import { call, put, select, takeEvery } from 'redux-saga/effects'
import { toast } from 'react-toastify'

// import { attemptReAuth, attemptVoid } from './cardReader'

import { orderDetailsRequested } from '../../actions/order'
import { COMBINE_ORDERS, combineOrdersFailed } from '../../actions/orders/combine'

import MutationApi from '../../remote/mutationApi'

import { makeGetOrder } from '../../selectors/order'
import Log from '../../utils/Log'

const getOrder = makeGetOrder()

export function* combineOrders(params = {}) {
  const combinedOrderUuid = params?.payload?.combinedOrderUuid
  const destinationOrderUuid = params?.payload?.destinationOrderUuid
  const destinationOrder = yield select(getOrder, destinationOrderUuid)

  function* handleError(errorMessage, errObject = {}) {
    Log.error(`Combine order failed for order: ${destinationOrder.orderNumber}`, {
      combinedOrderUuid,
      destinationOrderUuid,
    })

    yield put(combineOrdersFailed({ ...errObject, combinedOrderUuid, destinationOrderUuid }))
  }

  try {
    const result = yield call(MutationApi.combineOrders, destinationOrderUuid, combinedOrderUuid)
    const applied = result?.data?.orderMutations?.[0]?.applied
    if (applied) {
      yield put(orderDetailsRequested(destinationOrderUuid))
      yield put(orderDetailsRequested(combinedOrderUuid))
    } 
  } catch (err) {
    const errorMessage = err?.response?.data?.errorMessage ?? "Sorry, but something went wrong"
    yield handleError(errorMessage, err)
  }
}

export function* watchCombineOrders() {
  yield takeEvery(COMBINE_ORDERS, combineOrders)
}
